export const menuLinks = [
    { title: "Home", path: '/home' },
    { title: "Gifts & Experiences", path: '/event-promotions' },
    { title: "Find your way around", path: '/map-preview' },
    { title: "Find your perfect dish", path: '/suggest-menu' },
    { title: "Win Bigger", path: 'https://xela.co/s/tab-survey', isExternal: true },
    { title: "T&C", path: '/terms' },
]